export default "assets/logo-682fae80.svg";